import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction, useState } from "react";

import CrossCountry from "~/types/cross-country";

import RevieveModalTrigger from "../editorials/revieve-modal-trigger/revieve-modal-trigger";
import Breadcrumbs, { Breadcrumb } from "./product-breadcrumbs";
import ProductDetailTags from "./product-detail-tags";
import ProductGalleryNavigator from "./product-gallery-navigator";
import styles from "./product-intro.module.scss";

type Props = {
  root: CrossCountry.DetailedProduct;
  selectedShade: CrossCountry.DetailedProduct;
  galleryIdx: number;
  onSelect: (galleryElIdx: number) => void;
  breadcrumbs: Breadcrumb[];
  enabledGallery: boolean;
  setEnabledGallery: Dispatch<SetStateAction<boolean>>;
};

export default function ProductIntro(props: Props) {
  const t = useTranslations();
  const [showSku, setShowSku] = useState(!1);

  const handleDoubleClick = (e: React.MouseEvent<HTMLHeadingElement>) => {
    if (e.shiftKey) {
      setShowSku(!showSku);
    }
  };

  const sanitizeShortDescription = props.selectedShade.short_description?.replace(/<\/?p>/g, "");

  return (
    <div className={styles.pdpIntro}>
      <Breadcrumbs breadcrumbs={props.breadcrumbs} className={styles.pdpIntroBreadcrumb} />
      <ProductDetailTags product={props.selectedShade} />
      {showSku ? (
        <h1 className={styles.productName} onDoubleClick={handleDoubleClick} title={props.root.display_value}>
          {props.selectedShade.backend_id}
        </h1>
      ) : (
        <h1 className={styles.productName} onDoubleClick={handleDoubleClick}>
          {props.root.display_value?.toLowerCase()}
        </h1>
      )}
      <h2 className={styles.pdpShortDesc} dangerouslySetInnerHTML={{ __html: sanitizeShortDescription }} />

      <div className={styles.showOnDesktopOnly}>
        <RevieveModalTrigger
          revieveType="PDPVirtualTryOn"
          variant="serviceBig"
          buttonText={t("generic.tryitnow")}
          productId={props.selectedShade.backend_id}
          renderToId="revieve-target"
          hidden={!props.selectedShade.try_it_on}
          onOpen={() => props.setEnabledGallery(false)}
          onClose={() => props.setEnabledGallery(true)}
        />
        <ProductGalleryNavigator
          selectedShade={props.selectedShade}
          galleryIdx={props.galleryIdx}
          onSelect={props.onSelect}
          enabledGallery={props.enabledGallery}
        />
      </div>
    </div>
  );
}
